import { CashDetail } from './CashDetail';

export default CashDetail;
